import { AgGridReact } from 'ag-grid-react';
import { isMobile } from 'react-device-detect';
import React, { useEffect, useState } from 'react';

import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-blue.css';

import '../../ag-grid.css';
import moment from 'moment';
import { FLASH_DURATION_NEW_ALERT } from 'constants/settings';

const AgGrid = (props) => {
  const [excelStyles] = useState(props.excelStyles || []);
  const [rowSelection] = useState(props.rowSelection || 'single');
  const [context] = useState({ componentParent: this });
  const [gridApi, setGridApi] = useState();
  const [localeText] = useState({
    andCondition: 'et',
    orCondition: 'ou',
    page: 'Page',
    more: 'Plus',
    to: 'de',
    of: 'à',
    next: 'Suivant',
    last: 'Dernier',
    first: 'Premier',
    previous: 'Précédent',
    loadingOoo: 'Chargement...',
    selectAll: 'Sélectionner tout',
    searchOoo: 'Recherche...',
    blanks: 'Vide',
    filterOoo: 'Filtre...',
    applyFilter: 'Appliquer',
    resetFilter: 'Réinitialiser',
    equals: 'Égal',
    notEqual: 'Non égal',
    lessThan: 'Inférieur à',
    greaterThan: 'Supérieur à',
    lessThanOrEqual: 'Inférieur ou égal',
    greaterThanOrEqual: 'Supérieur ou égal',
    inRange: 'Dans la plage',
    contains: 'Contient',
    notContains: 'Ne contient pas',
    startsWith: 'Commence par',
    endsWith: 'Termine par',
    group: 'Groupe',
    columns: 'Colonne',
    filters: 'Filtres',
    rowGroupColumns: 'Colonne groupe',
    rowGroupColumnsEmptyMessage: 'Cononne groupe vide',
    valueColumns: 'Valeur de colonne',
    pivotMode: 'Mode pivot',
    groups: 'Groupe',
    values: 'Valeur',
    pivots: 'Pivot',
    valueColumnsEmptyMessage: 'Glisser la colonne pour aggréger',
    pivotColumnsEmptyMessage: 'Glisser la colonne pour pivot',
    toolPanelButton: 'Bouton du panneau d\'outils',
    noRowsToShow: 'Aucune ligne à afficher',
    pinColumn: 'Colonne épinglée',
    valueAggregation: 'Valeur aggrégée',
    autosizeThiscolumn: 'Redimensionnement automatique pour cette colonne',
    autosizeAllColumns: 'Redimensionnement automatique pour toutes les colonnes',
    groupBy: 'Grouper par',
    ungroupBy: 'Dégrouper par',
    resetColumns: 'Réinitialiser colonnes',
    expandAll: 'Afficher tout',
    collapseAll: 'Masquer tout',
    toolPanel: 'Panneau d\'outils',
    export: 'Export',
    csvExport: 'Export en CSV',
    excelExport: 'Export en Excel',
    pinLeft: 'Épingler à gauche',
    pinRight: 'Épingler à droite',
    noPin: 'Ne pas épingler',
    sum: 'Somme',
    min: 'Minimum',
    max: 'Maximum',
    none: 'Aucun',
    count: 'Total',
    average: 'Moyenne',
    copy: 'Copier',
    copyWithHeaders: 'Copier avec les entêtes',
    ctrlC: 'Ctrl + C',
    paste: 'Coller',
    ctrlV: 'Ctrl + V',
  });

  useEffect(() => {
    if (props.agGridName === 'ag-grid-overflow' && gridApi) {
      const rowFlash = [];

      // Récupération des dernières alertes
      gridApi.forEachNode(node => {
        if (node.data?.notif === 1 && node.data?.alarmLastDateDeb && moment().diff(moment(node.data?.alarmLastDateDeb), "s") <= Number(FLASH_DURATION_NEW_ALERT)) {
          rowFlash.push(node);
        }
      });

      // Flash des dernières alarmes
      gridApi.flashCells({
        flashDelay: 1000,
        fadeDelay: Number(FLASH_DURATION_NEW_ALERT) * 1000,
        rowNodes: rowFlash,
      });
    }
  });

  // Recherche dans l'ag-grid
  useEffect(() => {
    if (gridApi && props.filters?.search && props.agGridName === "ag-grid-overflow") {
      if (props.filters.search?.length > 0) {
        gridApi.setQuickFilter(props.filters.search);
      } else {
        gridApi.setQuickFilter();
      }
    }
  }, [props.filters?.search, props.rowData, gridApi]);

  // Gestion du chargement du composant
  const onGridReady = (params) => {
    if (!gridApi) {
      setGridApi(params.api);
    }
  };

  return (
    <div className="ag-theme-blue" style={{ boxSizing: 'border-box', height: props.height }}>
      {props.rowData !== undefined &&
        <AgGridReact
          rowData={props.rowData}
          columnDefs={props.columnDefs}
          rowHeight={props.rowHeight}
          sortable={props.sortable}
          unSortIcon={true}
          animateRows={true}
          rowSelection={rowSelection}
          excelColumns={props.excelColumns}
          excelStyles={excelStyles}
          context={context}
          gridOptions={props.gridOptions}
          pagination={props.pagination !== null ? props.pagination : false}
          paginationPageSize={props.paginationPageSize}
          localeText={localeText}
          suppressRowClickSelection={true}
          frameworkComponents={props.frameworkComponents}
          enableCellTextSelection={true}
          reactUi={true}
          maintainColumnOrder={true}
          onGridReady={onGridReady}
          onCellDoubleClicked={props.handleOnDoubleClick ? props.handleOnDoubleClick : null}
        />
      }
    </div>
  );
};

export default AgGrid;
